var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 320 320",
    style: {
      enableBackground: "new 0 0 320 320"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{opacity:0.3;fill:none;stroke:#4698CA;enable-background:new    ;}\r\n\t.st3{fill:none;stroke:#4698CA;}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;}\r\n\t.st5{fill:#FFFFFF;}\r\n\t.st6{fill:none;}\r\n\t.st7{fill:#020301;}\r\n\t.st8{clip-path:url(#SVGID_2_);}\r\n\t.st9{clip-path:url(#SVGID_4_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grid",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 70,
    y1: 0,
    x2: 70,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 80,
    y1: 0,
    x2: 80,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 90,
    y1: 0,
    x2: 90,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 100,
    y1: 0,
    x2: 100,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 110,
    y1: 0,
    x2: 110,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 120,
    y1: 0,
    x2: 120,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 130,
    y1: 0,
    x2: 130,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 140,
    y1: 0,
    x2: 140,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 150,
    y1: 0,
    x2: 150,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 160,
    y1: 0,
    x2: 160,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 170,
    y1: 0,
    x2: 170,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 180,
    y1: 0,
    x2: 180,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 190,
    y1: 0,
    x2: 190,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 200,
    y1: 0,
    x2: 200,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 210,
    y1: 0,
    x2: 210,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 220,
    y1: 0,
    x2: 220,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230,
    y1: 0,
    x2: 230,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 240,
    y1: 0,
    x2: 240,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 250,
    y1: 0,
    x2: 250,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 260,
    y1: 0,
    x2: 260,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 270,
    y1: 0,
    x2: 270,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 280,
    y1: 0,
    x2: 280,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 290,
    y1: 0,
    x2: 290,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 300,
    y1: 0,
    x2: 300,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 310,
    y1: 0,
    x2: 310,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 10,
    x2: 320,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 20,
    x2: 320,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 30,
    x2: 320,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 40,
    x2: 320,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 50,
    x2: 320,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 60,
    x2: 320,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 70,
    x2: 320,
    y2: 70
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 80,
    x2: 320,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 90,
    x2: 320,
    y2: 90
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 100,
    x2: 320,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 110,
    x2: 320,
    y2: 110
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 120,
    x2: 320,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 130,
    x2: 320,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 140,
    x2: 320,
    y2: 140
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 150,
    x2: 320,
    y2: 150
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 160,
    x2: 320,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 170,
    x2: 320,
    y2: 170
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 180,
    x2: 320,
    y2: 180
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 190,
    x2: 320,
    y2: 190
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 200,
    x2: 320,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 210,
    x2: 320,
    y2: 210
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 220,
    x2: 320,
    y2: 220
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 230,
    x2: 320,
    y2: 230
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 240,
    x2: 320,
    y2: 240
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 250,
    x2: 320,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 260,
    x2: 320,
    y2: 260
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 270,
    x2: 320,
    y2: 270
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 280,
    x2: 320,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 290,
    x2: 320,
    y2: 290
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 300,
    x2: 320,
    y2: 300
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 310,
    x2: 320,
    y2: 310
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M273.4,98.2c0.6,0.9,1.1,1.9,1.6,2.9C274.5,100,274,99.1,273.4,98.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M276.7,188.1L276.7,188.1c13-20.3,26.2-45.2,28.8-66.1c0-0.1,0-0.2,0-0.2c0,0.1,0,0.2,0,0.2 C302.9,142.9,289.7,167.8,276.7,188.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M270.8,94.8c0.7,0.8,1.3,1.6,1.9,2.4C272.1,96.4,271.5,95.6,270.8,94.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M276.9,105.6c0.3,0.9,0.5,1.9,0.7,2.9C277.4,107.5,277.2,106.5,276.9,105.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M272.5,132.1c-0.6,0.9-1.3,1.8-2.1,2.6C271.1,133.9,271.8,133,272.5,132.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M277.6,120.5c-0.2,0.8-0.4,1.7-0.6,2.5C277.2,122.2,277.4,121.4,277.6,120.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M274.9,128.2c-0.4,0.8-0.9,1.6-1.3,2.3C274.1,129.8,274.5,129,274.9,128.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M305.9,118.1c0,0.4-0.1,0.9-0.1,1.3c-0.1,0.8-0.2,1.5-0.2,2.3c0.1-0.8,0.2-1.5,0.2-2.3 C305.8,119,305.8,118.6,305.9,118.1c0.1-1.2,0.1-2.4,0.1-3.6c0-10-2.5-19.4-7-27.6c4.5,8.2,7,17.6,7,27.6 C306,115.7,305.9,116.9,305.9,118.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M276.4,124.8c-0.4,1.2-0.9,2.3-1.5,3.4C275.5,127.1,276,126,276.4,124.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M273.6,130.5c-0.3,0.6-0.7,1.1-1.1,1.6C272.9,131.6,273.2,131.1,273.6,130.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M296.1,82.1c1,1.5,2,3.1,2.9,4.8C298.1,85.3,297.2,83.7,296.1,82.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M272.7,97.2c0.2,0.3,0.4,0.6,0.7,1C273.2,97.8,273,97.5,272.7,97.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M275,101c0.3,0.6,0.6,1.2,0.8,1.8C275.6,102.2,275.3,101.6,275,101z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M278.1,117.6c-0.1,1-0.3,2-0.5,3C277.8,119.6,278,118.6,278.1,117.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M277,123c-0.2,0.6-0.4,1.2-0.6,1.8C276.6,124.2,276.8,123.6,277,123z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M265.8,138.8c1.7-1.2,3.2-2.6,4.6-4.1C269,136.2,267.5,137.6,265.8,138.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M269.4,93.2c0.5,0.5,1,1,1.4,1.5C270.4,94.3,269.9,93.7,269.4,93.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,130.1L64.8,160l89.1,54.6c1.8,1.1,3.9,1.7,6,1.7c2.1,0,4.2-0.6,6-1.7l89.1-54.6l48.9-29.9c3.4-2.1,5.5-5.8,5.5-9.8 s-2.1-7.7-5.5-9.8L166,26c-1.8-1.1-3.9-1.7-6-1.7c-2.1,0-4.2,0.6-6,1.7L16,110.5c-3.4,2.1-5.5,5.8-5.5,9.8S12.6,128,16,130.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,189.9l-26.8-16.4L178,234.2c-5.4,3.3-11.6,5.1-18,5.1c-6.4,0-12.6-1.8-18-5.1l-99.2-60.7L16,189.9 c-3.4,2.1-5.5,5.8-5.5,9.8c0,4,2.1,7.7,5.5,9.8L154,294c1.9,1.1,3.9,1.7,6,1.7c2.1,0,4.1-0.6,6-1.7l138-84.5 c3.4-2.1,5.5-5.8,5.5-9.8C309.5,195.7,307.4,192,304,189.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOverlay);
export default __webpack_public_path__ + "static/media/Icon_Overlay.39276472bcff6c793f1001fe2dd3ae04.svg";
export { ForwardRef as ReactComponent };